export const DISPLAY_LOCALE = 'en-US';

export function formatDisplayDate(dateString, options = {}) {
  if (dateString == null || dateString === '') return '';
  const date = new Date(dateString);
  if (Number.isNaN(date.getTime())) return '';
  return date.toLocaleDateString(DISPLAY_LOCALE, options);
}

export function formatDisplayDateTime(dateString, options = {}) {
  if (dateString == null || dateString === '') return '';
  const date = new Date(dateString);
  if (Number.isNaN(date.getTime())) return '';
  return date.toLocaleString(DISPLAY_LOCALE, options);
}

export function formatDisplayDateRange(startDate, endDate) {
  const start = formatDisplayDate(startDate);
  const end = formatDisplayDate(endDate);
  return start === end ? start : `${start} - ${end}`;
}

/** API `leave_type_name` is Japanese (name_ja); prefer name_en from /leave-types. */
export function resolveLeaveTypeName(application, leaveTypes) {
  if (!application) return '';
  const lt = leaveTypes?.find((t) => Number(t.id) === Number(application.leave_type_id));
  if (lt) return lt.name_en || lt.name_ja || application.leave_type_name || '';
  return resolveLeaveTypeLabel(application.leave_type_name, leaveTypes);
}

/** Resolve English leave type label when API only returns Japanese name (e.g. admin stats). */
export function resolveLeaveTypeLabel(japaneseName, leaveTypes) {
  if (!japaneseName) return '';
  const lt = leaveTypes?.find((t) => t.name_ja === japaneseName);
  if (lt) return lt.name_en || lt.name_ja || japaneseName;
  return japaneseName;
}
